import { CallcardStampsService } from '@addins/core/journal';
import { CardPageService } from '@addins/core/singlecallcard/services/card-page/card-page.service';
import { Component } from '@angular/core';
import { CallcardService } from '@services/callcard/callcard.service';
import { Events } from '@services/events/events.service';
import { NavService } from '@services/navigation/navigation.service';
import { ViewConfigurationService } from '@services/view-configuration/view-configuration.service';
import { AddinView } from '@techwan/ionic-core';
import { CallcardDetailBaseComponent } from '../../components/callcard-detail-base/callcard-detail-base.component';
import { MediaToolsProviderService } from '../../services/media-tools-provider/media-tools-provider.service';

@Component({
  templateUrl: 'page-detail-view.component.html',
  styleUrls: ['page-detail-view.component.scss']
})
@AddinView({
  name: 'PageView'
})
export class PageDetailViewComponent extends CallcardDetailBaseComponent {
  hasMediaTools: boolean;

  constructor(
    private readonly mediaTools: MediaToolsProviderService,
    cardService: CallcardService,
    events: Events,
    navService: NavService,
    view: ViewConfigurationService,
    _pages: CardPageService,
    private callcardStamps: CallcardStampsService
  ) {
    super(cardService, events, navService, view, _pages);
  }

  ngOnInit() {
    super.ngOnInit();
    this.hasMediaTools = this.mediaTools.mediaTools.length > 0;
  }

  addMedia() {
    this.mediaTools.openTools(this.callcard);
  }

  refreshStamp() {
    this.callcardStamps.$refreshStamps.emit();
  }
}
